import { COLOR } from '@/shared/constant/color'
import { ModalBtn } from '@/styles/common/CommonForm/buttonform'
import { ModalAlertContent } from '@/styles/common/modal'
import { ModalDefaultTitle, ModalTermsContents } from '@/styles/common/modal'

const TermsModal = (props: any) => {
  const { option, ClickFunc } = props
  const { title, content } = option

  const isContentTypeText = !content.includes('<p>') //content: text string | html <element> string

  return (
    <ModalAlertContent>
      <ModalDefaultTitle>{title}</ModalDefaultTitle>
      <ModalTermsContents
        isContentTypeText={isContentTypeText}
        dangerouslySetInnerHTML={{ __html: content }}
      />
      <ModalBtn bgColor={COLOR.point1} onClick={ClickFunc}>
        <span>확인</span>
      </ModalBtn>
    </ModalAlertContent>
  )
}
export default TermsModal
